import { ExtJsFilter } from '../../../../../../grid/utils/filters/types';

export enum TargetsColumn {
  NAME = 0,
  POLICY = 1,
  INHERITED_FROM = 2,
  ENFORCED = 3,
}

export enum TargetsColumnKeys {
  NAME = 'name',
  POLICY = 'policy',
  POLICY_ID = 'activePolicy.policyId',
  INHERITED_FROM = 'assignedPolicy.inheritedFrom.name',
  ENFORCED = 'assignedPolicy.enforced',
}

export interface TargetsReadRecordsParams {
  limit: number;
  page: number;
  protectedEntityId: Array<string>;
  sort?: string;
  dir?: string;
  filter?: Array<ExtJsFilter<TargetsColumnKeys>>;
}
